/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';
import axios2 from 'axios';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  // eslint-disable-next-line class-methods-use-this
  getTemplatesGupshup(appName, apikey) {
    return axios2.get(
      `https://api.gupshup.io/sm/api/v1/template/list/${appName}`,
      { headers: { apikey } }
    );
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }
}

export default new Inboxes();
